var map = {
	"./avatarF1.jpg": 1325,
	"./avatarF2.jpg": 3522,
	"./avatarF3.jpg": 9903,
	"./avatarF4.jpg": 7172,
	"./avatarF5.jpg": 769,
	"./avatarM1.jpg": 2764,
	"./avatarM2.jpg": 5563,
	"./avatarM3.jpg": 4430,
	"./avatarM4.jpg": 5253,
	"./avatarM5.jpg": 2888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 969;